import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { Account } from '../../services';

export type AccountState = {
  accounts: Partial<Account>[];
  selectedAccount: Partial<Account> | null;
  setSelectedAccount: (account: Account) => void;
  setAccounts: (accounts: Account[]) => void;
};

const useAccountStore = create(
  persist<AccountState>(
    set =>
      ({
        accounts: [],
        selectedAccount: null,
        setSelectedAccount: (account: Account) =>
          set({
            selectedAccount: account,
          }),
        setAccounts: (accounts: Account[]) =>
          set({
            accounts,
          }),
      } as AccountState),
    {
      name: '@tenGovUseAccountStore',
    },
  ),
);

export default useAccountStore;
